import InputGridLabel from "./InputGridLabel";

## Basic Label

<InputGridLabel text="Simple Label" />

---

## Required Field

<InputGridLabel text="Required Field" required />

Shows an asterisk indicator.

---

## With Secondary Text

<InputGridLabel text="Main Label" secondaryText="This is helpful secondary information" />

---

## With Tooltip

<InputGridLabel text="Complex Field" tooltip="Additional context and help information" />

Hover over the info icon to see the tooltip.

---

## Full Featured

<InputGridLabel
  text="Complete Example"
  required
  secondaryText="All features combined"
  tooltip="Main text, required indicator, secondary text, and tooltip"
/>

---

## With Rich Content

<InputGridLabel
  text={
    <span>
      <strong>Important:</strong> API Configuration
    </span>
  }
  secondaryText={<em>This setting affects all API calls</em>}
  tooltip="Changes require server restart"
/>
